<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100"
          >
           <br /> <br /> <br />
            <h2 class="title"></h2>
            <h2 class="title"></h2>
            <h4>
              Building games that dignify the interest of players and continuously improving the gaming experience, making games a part of life
            </h4>
            <br />
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section text-center">
        <div class="container">
          <h2 class="title"> Best Games Simulators </h2>
          <div class="team">
            <div class="md-layout">
              <div class="md-layout-item md-large-size-50 md-medium-size-50 md-small-size-100">
                <div class="team-player">
                  <md-card class="md-card-plain">
                    <div class="md-layout-item md-size-50 mx-auto">
                      <img
                        :src="teamImg1"
                        alt="Thumbnail Image"
                        class="img-raised rounded-circle img-fluid"
                      />
                    </div>
                    <h4 class="card-title">
                      Catalina Hummer Offroad
                      <br />
                    </h4>
                    <md-card-actions class="text-center">
                     
                      <md-button              
                       class="md-simple">
                        <a href='https://play.google.com/store/apps/details?id=com.actiongame.offroadhummer'
                        target="_blank">
                        <img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/></a>
                      </md-button>     
                    </md-card-actions>
                  </md-card>
                </div>
              </div>
              <div class="md-layout-item md-large-size-50 md-medium-size-50 md-small-size-100">
                <div class="team-player">
                  <md-card class="md-card-plain">
                    <div class="md-layout-item md-size-50 mx-auto">
                      <img
                        :src="teamImg2"
                        alt="Thumbnail Image"
                        class="img-raised rounded-circle img-fluid"
                      />
                    </div>
                    <h4 class="card-title">
                      Crime & Revenge City 
                      <br />
                    </h4>

                   <md-card-actions class="text-center">
                      <md-button
                       class="md-simple">
                        <a href='https://play.google.com/store/apps/details?id=com.actiongame.CrimeCity'
                        target="_blank">
                        <img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/></a>
                      
                      </md-button>                       
                                       
                    </md-card-actions>
                  </md-card>
                </div>
              </div>
               <div class="md-layout-item md-large-size-50 md-medium-size-50 md-small-size-100">
                <div class="team-player">
                  <md-card class="md-card-plain">
                    <div class="md-layout-item md-size-50 mx-auto">
                      <img
                        :src="teamImg3"
                        alt="Thumbnail Image"
                        class="img-raised rounded-circle img-fluid"
                      />
                    </div>
                    <h4 class="card-title">
                      Driving Simulator Ultimate Pro
                      <br />
                    </h4>
                    <md-card-actions class="text-center">
                     
                      <md-button              
                       class="md-simple">
                        <a href='https://play.google.com/store/apps/details?id=com.actiongame.offroadUltimate'
                        target="_blank">
                        <img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/></a>
                      </md-button>     
                    </md-card-actions>
                  </md-card>
                </div>
              </div>
              <div class="md-layout-item md-large-size-50 md-medium-size-50 md-small-size-100">
                <div class="team-player">
                  <md-card class="md-card-plain">
                    <div class="md-layout-item md-size-50 mx-auto">
                      <img
                        :src="teamImg4"
                        alt="Thumbnail Image"
                        class="img-raised rounded-circle img-fluid"
                      />
                    </div>
                    <h4 class="card-title">
                      US Police Bus Parking
                      <br />
                    </h4>

                   <md-card-actions class="text-center">
                      <md-button
                       class="md-simple">
                        <a href='https://play.google.com/store/apps/details?id=com.actiongames.USPoliceBusParking'
                        target="_blank">
                        <img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/></a>
                      
                      </md-button>                       
                                       
                    </md-card-actions>
                  </md-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      
      </div>
    </div>
  </div>
</template>

<script>
/*
eslint-disable
*/
export default {
  bodyClass: "landing-page",
  props: {
        header: {
      type: String,
      default: require("@/assets/img/car_racing.jpg")
    },
    teamImg1: {
      type: String,
      default: require("@/assets/img/faces/Catalina Hummer Jeep.png")
    },
    teamImg2: {
      type: String,
      default: require("@/assets/img/faces/Crime & Revenge City.png")
    },
    teamImg3: {
      type: String,
      default: require("@/assets/img/faces/Driving Simulator Ultimate Pro.png")
    },
    teamImg4: {
      type: String,
      default: require("@/assets/img/faces/US Police Bus Parking.png")
    }

    
  },
  data() {
    return {
      name: null,
      email: null,
      message: null
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
</style>
